export default __webpack_public_path__ + "static/media/site-outline.458f8d4f.svg";